import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { NgxAimStationSelectTime } from './ngx-aim-station-select-time.class';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'ngx-aim-station-select-time',
  standalone: true,
  imports: [ButtonModule, FormsModule, ProgressSpinnerModule],
  templateUrl: './ngx-aim-station-select-time.component.html',
  styleUrl: './ngx-aim-station-select-time.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxAimStationSelectTimeComponent extends NgxAimStationSelectTime implements OnInit {
  ngOnInit() {
    this.init();
  }
}
